import React from 'react';

function BreadcrumbDotSeparator() {
  return (
    <span className="breadcrumb-dot-separator" />
  );
}

export default BreadcrumbDotSeparator;
